/* eslint-disable complexity */
import { Arbeitsbereich } from '@/domain/mitarbeiter/features/rotationsplan/entities/Arbeitsbereich';
import { Mitarbeiter } from '@/domain/mitarbeiter/features/rotationsplan/entities/Mitarbeiter';
import { ArbeitsbereichKalenderStation } from '@/domain/mitarbeiter/features/rotationsplan/entities/Station';

type Event = {
  date: Date;
  type: 'start' | 'end';
  stationId: string;
  mitarbeiter: Mitarbeiter;
};

/* eslint-disable max-lines-per-function */
export function transformMitarbeiterStationenToArbeitsbereichStationen(
  data: Mitarbeiter[],
): Arbeitsbereich[] {
  const arbeitsbereicheMap: Record<
    string,
    {
      arbeitsbereich: Arbeitsbereich;
      stationen: Array<{
        id: string;
        von: Date;
        bis: Date;
        mitarbeiter: Mitarbeiter;
      }>;
    }
  > = {};

  data.forEach((m) => {
    m.stationen.forEach((station) => {
      const bereichId = station.arbeitsbereich.id;
      if (!arbeitsbereicheMap[bereichId]) {
        arbeitsbereicheMap[bereichId] = {
          arbeitsbereich: new Arbeitsbereich({
            id: bereichId,
            name: station.arbeitsbereich.name,
            markierung: station.arbeitsbereich.markierung,
          }),
          stationen: [],
        };
      }
      arbeitsbereicheMap[bereichId].stationen.push({
        id: station.id,
        von: station.von,
        bis: station.bis,
        mitarbeiter: new Mitarbeiter({
          id: m.id,
          vorname: m.vorname,
          nachname: m.nachname,
          beruf: m.beruf,
          lehrjahr: m.lehrjahr,
        }),
      });
    });
  });

  const result: Arbeitsbereich[] = [];
  Object.values(arbeitsbereicheMap).forEach(({ arbeitsbereich, stationen }) => {
    const events: Event[] = [];

    stationen.forEach(({ id, von, bis, mitarbeiter }) => {
      events.push({ stationId: id, date: von, type: 'start', mitarbeiter });
      const bisPlus1 = new Date(bis);
      bisPlus1.setDate(bisPlus1.getDate() + 1);
      events.push({ stationId: id, date: bisPlus1, type: 'end', mitarbeiter });
    });

    events.sort((a, b) => {
      if (a.date.getTime() !== b.date.getTime())
        return a.date.getTime() - b.date.getTime();
      return a.type === 'start' ? -1 : 1;
    });

    let active: Mitarbeiter[] = [];
    let lastDate: Date | null = null;
    const arbeitsbereicheStationen: ArbeitsbereichKalenderStation[] = [];

    for (const event of events) {
      if (lastDate && lastDate < event.date) {
        const bis = new Date(event.date);
        bis.setDate(bis.getDate() - 1);
        if (active.length > 0 && lastDate <= bis) {
          arbeitsbereicheStationen.push(
            new ArbeitsbereichKalenderStation({
              id: event.stationId,
              von: lastDate,
              bis,
              mitarbeiter: active.map((m) => m),
            }),
          );
        }
      }

      if (event.type === 'start') {
        active.push(event.mitarbeiter);
      } else {
        active = active.filter((m) => m.id !== event.mitarbeiter.id);
      }
      lastDate = event.date;
    }
    arbeitsbereich.stationen = arbeitsbereicheStationen;
    result.push(arbeitsbereich);
  });
  return result;
}
